import { Text, Select, Pagination } from '@mantine/core';
import type { Table } from '@tanstack/react-table';
import React from 'react';
import { DataTableResultCount } from './DataTableResultCount';
import DataTableRowsSelected from './DataTableRowsSelected';

type DataTablePaginationControlsProps<TData> = {
  table: Table<TData>;
  itemName: string;
  showResultsCount?: boolean;
  showSelectedCount?: boolean;
};

// TODO: rename this to DataTablePaginationAndSelectedCountControls
export default function DataTablePaginationControls<TData>({
  table,
  itemName,
  showResultsCount = true,
  showSelectedCount = true,
}: DataTablePaginationControlsProps<TData>) {
  return (
    <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
      <div className="flex w-full flex-1 items-center justify-center gap-4 sm:w-auto sm:justify-start">
        <Text className="text-sm text-gray-600 dark:text-gray-400">Rows per page</Text>
        <Select
          placeholder="Pick value"
          className="w-24"
          size="xs"
          data={['25', '50', '75', '100']}
          value={table.getState().pagination.pageSize.toString()}
          onChange={(value) => table.setPageSize(Number(value))}
        />
      </div>

      <div className="flex flex-none items-center justify-center">
        <Pagination.Root
          total={table.getPageCount()}
          value={table.getState().pagination.pageIndex + 1}
          onChange={(page) => table.setPageIndex(page - 1)}
        >
          <div className="flex items-center gap-2">
            <Pagination.First />
            <Pagination.Previous />
            <Pagination.Items />
            <Pagination.Next />
            <Pagination.Last />
          </div>
        </Pagination.Root>
      </div>

      <div className="flex w-full flex-1 items-center justify-center gap-2 sm:w-auto sm:justify-end">
        {!!(showResultsCount || showSelectedCount) && (
          <>
            {!!showResultsCount && (
              <DataTableResultCount
                table={table}
                suffix={`${itemName}${table.getRowCount() === 1 ? '' : 's'}`}
                className="text-sm"
              />
            )}
            {!!showResultsCount && !!showSelectedCount && (
              <span className="text-xs text-gray-600 dark:text-gray-400">&#x2022;</span>
            )}
            {!!showSelectedCount && (
              <DataTableRowsSelected
                table={table}
                className="text-sm"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
